import { isInputElement } from '@fabric-app/utils/element';
import { hasMacOSKbd } from '@fabric-app/utils/detection';

const defaultOptions = {
  stopOnFirstSuccess: true,
  stopPropagationOnHandle: false,
  preventDefaultOnHandle: false
};
const chainShortcutHandlers = (event, handlers, optionsArg) => {
  const options = {
    ...defaultOptions,
    ...optionsArg
  };
  let isAnyHandled = false;
  for (const handler of handlers) {
    const isHandled = handler(event);
    if (isHandled) {
      isAnyHandled = true;
    }
    if (options.stopOnFirstSuccess && isHandled) {
      break;
    }
  }
  if (isAnyHandled) {
    options.stopPropagationOnHandle && event.stopPropagation();
    options.preventDefaultOnHandle && event.preventDefault();
  }
  return isAnyHandled;
};
const isEnterCmdCtrl = (e) => {
  const macKeyboard = hasMacOSKbd();
  const isCtrlOrCmd = macKeyboard ? e.metaKey : e.ctrlKey;
  const isInteractive = isInputElement(e.target, true) && e.shiftKey;
  if (e.key === "Enter" && isCtrlOrCmd && !isInteractive) {
    return true;
  }
  return false;
};

export { chainShortcutHandlers, isEnterCmdCtrl };
//# sourceMappingURL=utils.js.map
